import React from "react";
import { useAuth } from "../../apis/auth/AuthProvider";
import { getUiInterface } from "../../locales/translationUtils";

/**
 * Faixa de aviso exibida enquanto a emulação está ligada.
 *
 * Existe por dois motivos. O primeiro é que a tela passa a ser a de outro perfil, e
 * sem um aviso permanente é fácil esquecer que o que está na frente não é a sua
 * própria visão do sistema. O segundo é que a emulação é somente leitura: melhor
 * dizer isso de saída do que deixar a pessoa descobrir ao tentar salvar.
 */
const FaixaDeEmulacao: React.FC = () => {
  const { emulacao, encerraEmulacaoAtual } = useAuth();

  if (!emulacao?.emulando) return null;

  const perfil = emulacao.perfilEmulado?.replace("ROLE_", "");
  const cliente = emulacao.clienteNome ?? (emulacao.clienteId != null ? `#${emulacao.clienteId}` : null);

  return (
    <div className="emulacao-faixa" role="status">
      <i className="bi bi-incognito"></i>

      <span>
        <strong>{getUiInterface("emulationActive")}</strong>{" "}
        {perfil && <>{getUiInterface("emulationAsRole")} <strong>{perfil}</strong></>}
        {perfil && cliente && " · "}
        {cliente && <>{getUiInterface("emulationOfClient")} <strong>{cliente}</strong></>}
        {" — "}
        {getUiInterface("emulationReadOnly")}
      </span>

      <button type="button" className="emulacao-sair" onClick={() => encerraEmulacaoAtual()}>
        {getUiInterface("emulationExit")}
      </button>
    </div>
  );
};

export default FaixaDeEmulacao;
